var _defs, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntellij(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "99.7986577%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "26%",
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46%",
    stopColor: "#B07B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72%",
    stopColor: "#577BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91%",
    stopColor: "#1E7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: ".34482759%",
    x2: "121.182266%",
    y1: "34.5396825%",
    y2: "77.6190476%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "7%",
    stopColor: "#CB7A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#9E7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#757B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#537BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "43%",
    stopColor: "#387CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "#237CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#147CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79%",
    stopColor: "#0B7CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "78.1690141%",
    x2: "30.1056338%",
    y1: "97.7493606%",
    y2: "-6.62404092%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8%",
    stopColor: "#CB417E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "16%",
    stopColor: "#9E4E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "34%",
    stopColor: "#5365CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44%",
    stopColor: "#386DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "#2374E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#1478F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79%",
    stopColor: "#0B7BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "20%",
    x2: "103.421589%",
    y1: "24.0865385%",
    y2: "132.676282%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "4%",
    stopColor: "#F63462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#DF3A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "17%",
    stopColor: "#C24383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "29%",
    stopColor: "#AD4A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92%",
    stopColor: "#1D76ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#087CFA"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m64.8 199.6-62-48.8 30.8-57.2L122 128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m256 68.4-4.8 148-98.4 39.6-59.2-38.4L180 128l-37.6-83.2 34-40.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m256 68.4-78 92-35.6-115.6 34-40.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M123.2 212.4 20.8 249.6 37.2 192l21.2-71.2L0 101.2 37.2 0l80 9.6 79.2 90.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h160v160H48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M63.2 178h60v10h-60v-10ZM106 80.8v-12H73.2v12h9.2v42h-9.2v12.4H106v-12.4h-9.2v-42h9.2Zm32 55.2c-4.566649.205984-9.110237-.757807-13.2-2.8-3.346034-1.845975-6.327998-4.285763-8.8-7.2l9.2-10.4c1.661272 1.82513 3.542265 3.43741 5.6 4.8 1.93613 1.135124 4.157474 1.69046 6.4 1.6 2.466127.188479 4.864692-.860893 6.4-2.8 1.852667-2.386058 2.712461-5.395334 2.4-8.4V68h14.8v43.2c.151789 3.537935-.391805 7.071293-1.6 10.4-1.055421 3.377032-2.987809 6.413641-5.6 8.8-4.533251 3.365567-9.961237 5.314074-15.6 5.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellij);
export default __webpack_public_path__ + "static/media/intellij.a0d1827f21f65c625e749cf490225f4b.svg";
export { ForwardRef as ReactComponent };